module.exports = __webpack_public_path__ + "static/media/aroldo-mostrandoabaixo-direita.fd41e350.svg";